import { useEffect, useContext } from 'react';
import { matchPath, RouteComponentProps } from 'react-router-dom';
import {
  BreadcrumbsContext,
  BreadcrumbsContextType,
} from 'providers/Breadcrumbs';
import type { RouterType } from 'commons/modules/routers/routes';

const useBreadcrumbs = (
  history: RouteComponentProps['history'],
  routes: RouterType[],
) => {
  const { updateBreadcrumbs } = useContext(
    BreadcrumbsContext,
  ) as BreadcrumbsContextType;
  useEffect(() => {
    const activeRoute = routes.find((route) => {
      const isMatch = matchPath(history.location.pathname, route);
      return isMatch?.isExact;
    });
    if (activeRoute) {
      updateBreadcrumbs(activeRoute.breadcrumbs as any);
    }
  }, [updateBreadcrumbs, routes, history.location.pathname]);
};

export default useBreadcrumbs;
